import { render, staticRenderFns } from "./MovieSingle.vue?vue&type=template&id=de9ccac4&"
import script from "./MovieSingle.vue?vue&type=script&lang=js&"
export * from "./MovieSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports